import { Avatar, Box, CardContent, Grid, Typography, Drawer, Button, Divider } from '@mui/material';
import EditButton from '../EditButton/EditButton';
import { FC, useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { IAccountingBasicInformation } from "../../utils/account.types";
import CardData from "../CardData/CardData";
import CustomDialogForm from "../Dialog/DialogForm";
import { fetchAccountById, updateAccount, removeAccountLogoOrSign } from "../../store/accountThunk";
import { StyledCard } from './AccountBacisInfo.styles';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const AccountBasicInfo: FC = () => {
  const dispatch = useAppDispatch();
  const [accountBasicInf, setaccountBasicInf] = useState<IAccountingBasicInformation>();
  const [logoUrl, setLogoUrl] = useState('')
  const [signatureUrl, setSignatureUrl] = useState('')
  const [open, setOpen] = useState(false);

  const accountDetails = useAppSelector(state => state.account.accountDetails);

  const cardClicked = () => {
    handleOpen();
  }

  const getData = (data: any): IAccountingBasicInformation => {
    const { name, displayName, legalName, tagline, companyDesc, industryVertical, businessType, website, contactName, email, whatsAppNumber, advanceAccounting } = data;
    return {
      'name': { value: name, title: 'Brand Name' },
      'displayName': { value: displayName, title: 'Display Name' },
      'legalName': { value: legalName || '', title: 'Legal Name' },
      'tagline': { value: tagline || '', title: 'Tagline' },
      'companyDesc': { value: companyDesc || '', title: 'Company Description' },
      'website': { value: website || '', title: 'Website' },
      'businessType': { value: businessType || '', title: 'Business Type' },
      'industryVertical': { value: industryVertical || '', title: 'Industry Vertical' },
      'contactName': { value: contactName || '', title: 'Business Contact Name' },
      'email': { value: email || '', title: 'Business Email' },
      'whatsAppNumber': { value: whatsAppNumber || '', title: 'Business Whatsapp Number' },
      'advanceAccounting': { value: advanceAccounting ? 'Enabled' : 'Disabled', title: 'Advance Accounting' },
    };
  };

  const getBasicInfoData = () => {
    const data = [];
    for (const key in accountBasicInf) {
      data.push(<CardData key={key} card={accountBasicInf[key as keyof IAccountingBasicInformation]} />)
    }
    return data;
  }

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const handleRemoveLogoOrSign = async (logoOrSign: any) => {
    let data: any = {};
    if (logoOrSign == 'logo') {
      data.logo = true;
    }
    if (logoOrSign == 'signature') {
      data.signature = true;
    }

    console.log(data);

    try {
      await dispatch(removeAccountLogoOrSign({
        id: accountDetails._id,
        accountPayload: data,
      })).then((data) => {
        if (data) {
          dispatch(fetchAccountById(accountDetails._id));
          handleClose();
        }
      }).catch(e => {
        //console.log(e);
      });;
    } catch (error: any) {
      // Empty catch block.
    }
  }

  const onSubmit = async (data: any) => {
    // Dispatch add account action.
    try {
      await dispatch(updateAccount({
        id: accountDetails._id,
        accountPayload: data,
      })).then((data) => {
        if (data) {
          dispatch(fetchAccountById(accountDetails._id));
          handleClose();
        }
      }).catch(e => {
        //console.log(e);
      });;
    } catch (error: any) {
      // Empty catch block.
    }
  };

  useEffect(() => {
    let basicInfoAvaliable = true;

    const basicInfo = () => {
      try {

        if (basicInfoAvaliable) {
          Object.keys(accountDetails).length && setaccountBasicInf(getData(accountDetails));
          setLogoUrl(accountDetails.logo)
          setSignatureUrl(accountDetails.signature)
        }
      } catch (error: any) {
        console.log('Company Profile catch block called')
      }
    };
    basicInfo();
    return () => {
      basicInfoAvaliable = false;
    };
  }, [accountDetails]);


  return (
    <>
      <div className={'c-card2'} style={{ padding: 12, paddingTop: 12 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, m: '-12px -12px 12px', px: '12px', py: 0.5, bgcolor: '#e9ecf1', borderBottom: '1px solid #dcdcdc', borderRadius: '8px 8px 0 0' }}>
          <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, margin: 0 }}>Company Profile</h5>
          <EditButton size='small' onClick={cardClicked} />
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.name.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountBasicInf?.name.value || '-'}</h5>
          </Grid>

          <Grid item xs={4}>
            <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.displayName.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountBasicInf?.displayName.value || '-'}</h5>
          </Grid>

          <Grid item xs={4}>
            <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.legalName.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountBasicInf?.legalName.value || '-'}</h5>
          </Grid>

          <Grid item xs={4}>
            <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.tagline?.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountBasicInf?.tagline?.value || '-'}</h5>
          </Grid>

          <Grid item xs={4}>
            <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.contactName?.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountBasicInf?.contactName?.value || '-'}</h5>
          </Grid>

          <Grid item xs={4}>
            <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.email?.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountBasicInf?.email?.value || '-'}</h5>
          </Grid>

          <Grid item xs={4}>
            <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.whatsAppNumber?.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountBasicInf?.whatsAppNumber?.value || '-'}</h5>
          </Grid>

          <Grid item xs={4}>
            <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.companyDesc.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountBasicInf?.companyDesc.value || '-'}</h5>
          </Grid>

          <Grid item xs={4}>
            <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.website.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountBasicInf?.website.value || '-'}</h5>
          </Grid>

          <Grid item xs={4}>
            <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.businessType.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountBasicInf?.businessType.value || '-'}</h5>
          </Grid>

          <Grid item xs={4}>
            <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.industryVertical.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountBasicInf?.industryVertical.value || '-'}</h5>
          </Grid>

          <Grid item xs={4}>
            <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13 }}>{accountBasicInf?.advanceAccounting?.title}</h5>
            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountBasicInf?.advanceAccounting?.value || '-'}</h5>
          </Grid>
        </Grid>

        <Drawer
          anchor="right"
          open={open}
        >
          {<CustomDialogForm title='Update Account' open={open} data={accountDetails} onClose={handleClose} onSubmit={onSubmit} />}
        </Drawer>
      </div>
      {/* {logoUrl && 
              <Grid item xs={12}>
                <Avatar
                  alt={'BI'}
                  imgProps={{ "referrerPolicy": 'no-referrer' }}
                  src={`${logoUrl}`}
                  variant='square'
                  style={{ margin:'auto', width: '130px', height: '130px', objectFit: 'contain' }}
                />
                <a onClick={()=> {
                  console.log("on click trigger");
                  handleRemoveLogoOrSign('logo');
                }} style={{cursor:'pointer', color: 'red'}}><RemoveCircleOutlineIcon style={{marginBottom:-2.8, fontSize:'16px'}}/> Remove Logo</a>
              </Grid> 
            }
            {signatureUrl &&
              <Grid item xs={12}>
                <Avatar
                  alt={'BI'}
                  imgProps={{ "referrerPolicy": 'no-referrer' }}
                  src={`${signatureUrl}`}
                  variant='square'
                  style={{ margin:'auto', width: '130px', height: '130px', objectFit: 'contain' }}
                />
                <a onClick={()=> {
                  console.log("on click trigger");
                  handleRemoveLogoOrSign('signature');
                }} style={{cursor:'pointer', color: 'red'}}><RemoveCircleOutlineIcon style={{marginBottom:-2.8, fontSize:'16px'}}/> Remove Signature</a>
              </Grid>
            } */}
    </>
  );
};

export default AccountBasicInfo;
